"use client";

import { useEffect, useRef, useState } from "react";
import { ACHIEVEMENTS, CERT_EVENT, onUnlock, openCertificate, unlock, type AchId } from "./achievements";
import Certificate from "./Certificate";
import Joke from "./Joke";

// Общий слой мулечек для всех дизайнов: уведомления об ачивках, удостоверение, заголовок вкладки, «Ночной дозор».
export default function FunLayer() {
  const [toasts, setToasts] = useState<{ key: number; id: AchId }[]>([]);
  const [certOpen, setCertOpen] = useState(false);
  const seq = useRef(0);

  // ачивки → уведомления
  useEffect(
    () =>
      onUnlock((id) => {
        const key = ++seq.current;
        setToasts((t) => [...t, { key, id }]);
        setTimeout(() => setToasts((t) => t.filter((x) => x.key !== key)), 5200);
      }),
    []
  );

  // удостоверение открывается событием из любого блока
  useEffect(() => {
    const open = () => setCertOpen(true);
    window.addEventListener(CERT_EVENT, open);
    return () => window.removeEventListener(CERT_EVENT, open);
  }, []);

  // «Ночной дозор»: визит с полуночи до пяти утра
  useEffect(() => {
    const h = new Date().getHours();
    if (h < 5) setTimeout(() => unlock("night"), 1500);
  }, []);

  // заголовок вкладки: ушли — «Голубь ждёт…», вернулись — «Вы что-то видели?»
  useEffect(() => {
    let original = document.title;
    let back: ReturnType<typeof setTimeout> | undefined;
    const onVis = () => {
      clearTimeout(back);
      if (document.hidden) {
        original = document.title.startsWith("Голубь ждёт") || document.title.startsWith("Вы что-то") ? original : document.title;
        document.title = "Голубь ждёт…";
      } else {
        document.title = "Вы что-то видели?";
        back = setTimeout(() => (document.title = original), 2600);
      }
    };
    document.addEventListener("visibilitychange", onVis);
    return () => {
      clearTimeout(back);
      document.removeEventListener("visibilitychange", onVis);
    };
  }, []);

  return (
    <>
      <div className="toasts" aria-live="polite">
        {toasts.map(({ key, id }) => (
          <div key={key} className="toast">
            <span className="toast__badge" aria-hidden="true">
              ★
            </span>
            <div>
              <b>Достижение: {ACHIEVEMENTS[id].title}</b>
              <p>{ACHIEVEMENTS[id].text}</p>
              <button type="button" className="toast__link" onClick={openCertificate}>
                В удостоверение →
              </button>
            </div>
          </div>
        ))}
      </div>
      <Certificate open={certOpen} onClose={() => setCertOpen(false)} />
      <Joke />
    </>
  );
}
